import {request} from '../utils/request';

/**
 * 获取用户角色分页列表
 * @param {Object} data - 查询参数
 */
export const getUserRolePageList = (data) => {
  return request({
    url: '/UserRole/GetPageList',
    method: 'post',
    data,
  });
};

/**
 * 获取用户角色详情
 * @param {number} id - 用户角色ID
 */
export const getUserRoleDetail = (id) => {
  return request({
    url: '/UserRole/GetDetail',
    method: 'get',
    params: { id },
  });
};

/**
 * 添加用户角色
 * @param {Object} data - 用户角色数据
 */
export const addUserRole = (data) => {
  return request({
    url: '/UserRole/Add',
    method: 'post',
    data,
  });
};

/**
 * 更新用户角色
 * @param {Object} data - 用户角色数据
 */
export const updateUserRole = (data) => {
  return request({
    url: '/UserRole/Update',
    method: 'post',
    data,
  });
};

/**
 * 更新用户角色状态
 * @param {Object} data - 状态数据
 * @param {number} data.IsEnabled - 是否启用 (0/1)
 * @param {Array<number>} data.Ids - 用户角色ID数组
 */
export const updateUserRoleStatus = (data) => {
  return request({
    url: '/UserRole/UpdateStatus',
    method: 'post',
    data,
  });
};
